import { gql } from "@apollo/client";
import { adaptProductosReclamo } from "./CreateReclamo";

const UPDATE_RECLAMO = gql`
    mutation updateGestionReclamo($input: EditGestionReclamoInput! ){
        updateGestionReclamo(input: $input ) {
            idGestionReclamo
        }
    }
`;

export default UPDATE_RECLAMO;

const stageAdapters = {
  // Etapa 1: Creador Reclamo
  stage1: (data) => ({
    pantallaCreadorReclamo: {
      tipoReclamo: data?.tipoReclamo,
      idDelegacion: data?.idDelegacion,
      idUsuarioCreador: data?.idUsuarioCreador,
      idCategoriaReclamo: data?.idCategoriaReclamo,
      fechaRegistro: data?.fechaRegistro,
      fechaOcurrencia: data?.fechaOcurrencia,
      contacto: data?.contacto,
      telefonoContacto: data?.telefonoContacto,
      empleado: data?.empleado,
      descripcion: data?.descripcion,
      accionInmediata: data?.accionInmediata,
      idPaciente: data?.idPaciente,
      idCliente: data?.idCliente,
      profesionales: data?.profesionales,
      productos: adaptProductosReclamo(data?.productos),
      tecnologiasMedicas: adaptProductosReclamo(data?.tecnologiasMedicas)
    }
  }),

  // Etapa 2: Calidad NH
  stage2: (data) => ({
    pantallaCalidadNH: {
      idAreaReclamo: data?.idAreaReclamo,
      idClasificacion: data?.idClasificacionReclamo,
      idUsuarioResponsable: data?.idUsuarioResponsable,
      idsEvaluacion: data?.evaluaciones,
      descripcionCalidad: data?.descripcionCalidad,
      accionInmediataCalidad: data?.accionInmediataCalidad,
      //EFI 
      seguridadSaludPaciente: !!data?.seguridadSaludPaciente,
      calidadServicio: !!data?.calidadServicio,
      justificacion: data?.justificacion,
      idCategoriaEFI: data?.idCategoriaEFI
    }
  }),

  // Etapa 3: Responsable Area
  stage3: (data) => ({
    pantallaResponsableArea: {
      investigacion: data.investigacion,
      capa: data.capa,
      accionTomada: data.accionTomada
    }
  }),

  // Etapa 4: Revision Coordinador
  stage4: (data) => ({
    pantallaRevisionCoordinador: {
      idSeguimientoFK: data.idSeguimientoFK,
      descripcionCierre: data.descripcionCierre,
      correspondeProfesional: !!data.correspondeProfesional,
      idCapaReclamo: data.idCapaReclamo
    }
  }),

  // Etapa 5: Jefe Calidad
  stage5: (data) => ({
    pantallaJefeCalidad: {
      observacionFinal: data.observacionFinal
    }
  })
};

export const adaptEditGestionReclamoInput = (stageData, idGestionReclamo, pantalla, idEstadoReclamo, idEtapaReclamo) => {
  const stageName = `stage${pantalla}`;
  const adapter = stageAdapters[stageName];

  if (!adapter) {
    throw new Error(`No existe adaptador para la etapa ${stageName}`);
  }

  // Construimos el input base con los campos requeridos
  const baseInput = {
    idGestionReclamo,
    pantalla,
    idEstadoReclamo,
    idEtapaReclamo,
    // Inicializamos todos los campos nullables como null
    pantallaCreadorReclamo: null,
    pantallaCalidadNH: null,
    pantallaResponsableArea: null,
    pantallaRevisionCoordinador: null,
    pantallaJefeCalidad: null
  };

  // Aplicamos el adaptador específico de la etapa y combinamos con el input base
  const adaptedStageData = adapter(stageData);
  return {
    ...baseInput,
    ...adaptedStageData
  };
};